import { useScrollReveal } from '../../../hooks/useScrollReveal';
import { benefits } from '../../../mocks/asesoriaImagen';

export default function BenefitsSection() {
  const { ref, style } = useScrollReveal({
    threshold: 0.1,
    distance: 32,
    duration: 800,
  });
  const { ref: refGrid, style: styleGrid } = useScrollReveal({
    threshold: 0.1,
    distance: 28,
    duration: 800,
    delay: 200,
  });

  return (
    <section className="w-full bg-brand-cream py-20 md:py-28 px-6 lg:px-[7%]">
      <div ref={ref} style={style} className="text-center max-w-2xl mx-auto">
        <span className="font-sans text-brand-gray-500 text-[11px] tracking-[0.2em] uppercase font-medium">
          Beneficios
        </span>
        <h2 className="font-serif text-brand-black text-[clamp(1.8rem,4vw,2.8rem)] leading-[1.3] mt-4">
          Lo que cambia cuando tu imagen trabaja para ti
        </h2>
      </div>
      <div
        ref={refGrid}
        style={styleGrid}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-12"
      >
        {benefits.map((b) => (
          <div
            key={b.id}
            className="bg-white rounded-2xl p-6 md:p-8 border border-brand-gray-200 text-center"
          >
            <div className="w-14 h-14 mx-auto rounded-full bg-brand-sage/40 flex items-center justify-center mb-5">
              <div className="w-6 h-6 flex items-center justify-center text-brand-black">
                <i className={`${b.icon} text-xl`} />
              </div>
            </div>
            <h3 className="font-serif text-brand-black text-lg font-medium">
              {b.title}
            </h3>
            <p className="font-sans text-brand-gray-500 text-sm leading-relaxed mt-3">
              {b.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}